<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-4">
        <vue-drag-tree
          :data="treeModel"
          :allowDrag="allowDrag"
          :allowDrop="allowDrop"
          :defaultText="'New Node'"
          :displayCheckBox="displayCheckBox"
          :createNodeFlag="true"
          :deleteNodeFlag="false"
          :isCreateLevel="true"
          :createLevel="lockLevel"
          :isFieldCreateFlag="true"
          :fieldCreateFlag="`is_control_product`"
          :negativity="true"
          :isNotCreateStatus="true"
          :statusNotCreate="statusNotCreate"
          @current-node-clicked="curNodeClicked"
          @drag="dragHandler"
          @drag-enter="dragEnterHandler"
          @drag-leave="dragLeaveHandler"
          @drag-over="dragOverHandler"
          @drag-end="dragEndHandler"
          @drop="dropHandler"
          @createNode="onCreateNode"
          @deleteNode="onDeleteNode"
        >
        </vue-drag-tree>
      </div>
      <div class="col-lg-8" v-if="isShowData">
        <div class="card">
          <div class="card-body" v-if="isEdit">
            <HybridCategoryDetailEditor
              ref="detailEditor"
              :isChanged.sync="isPayloadChanged"
              :isChild="is_child"
              v-model="input"
            />
            <div class="row">
              <div class="col-md-6">
                <div class="text-left">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="onBack()"
                    >
                      <i
                        class="bx bx-arrow-back font-size-16 align-middle mr-2"
                      ></i>
                      Back
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="text-right">
                  <div class="button-items">
                    <button
                      v-if="isPayloadChanged"
                      type="button"
                      class="btn btn-send-approve"
                      @click="onSubmit"
                    >
                      <i class="bx bx-user-check" />
                      Send to Approve
                    </button>

                    <button
                      type="reset"
                      class="btn btn-light"
                      @click="onConfirmReset"
                    >
                      <i class="bx bx-reset" />Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-else>
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    v-show="isShowEditBtn"
                    @click="onEdit()"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit Hybrid
                  </button>
                </div>
              </div>
            </div>
            <HybridCategoryDetailView v-model="input" />
            <div class="button-items" style="float: left">
              <button type="button" class="btn btn-light" @click="onBack()">
                <i class="bx bx-arrow-back" />Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-create-view
      :activeModal="modal.createView"
      :parent_id="parent_id"
      :parent_status="parent_status"
      :level="level"
      :root="root"
      :commission_rate="commission_rate"
      @hidden="modal.createView = false"
      @createView="createView"
    ></modal-create-view>
    <!-- <confirm-modal :show="modal.confirm" bodyText="Confirm update"
            @hidden="modal.confirm = false" @confirm="updateView"></confirm-modal>
          <confirm-delete-modal :show="modal.deleteView" :bodyText="'Confirm delete'"
            @hidden="modal.deleteView = false" @confirm="deleteView"></confirm-delete-modal> -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import VueDragTree from '@/libs/vue-drag-tree/src/VueDragTree'

import PageHeader from '@/components/page-header'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import modalCreateView from '@/components/view-interface/hybrid-category/modalCreateView'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import HybridCategoryDetailView from '@/components/hybrid-category/view'
import HybridCategoryDetailEditor from '@/components/hybrid-category/editor'
import { HybridLockLevel } from '@/enum/hybrid-category.enum.js'
export default {
  components: {
    PageHeader,
    'vue-drag-tree': VueDragTree,
    'modal-create-view': modalCreateView,
    HybridCategoryDetailView,
    HybridCategoryDetailEditor,
  },
  data() {
    return {
      id: '',
      title: 'Hybrid Category',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Hybrid Category',
          href: '/hybrid-categories',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      treeModel: [
        {
          view_id: null,
          view_name: 'Root',
          parent_id: null,
          level: 0,
          sequence: 0,
          status: StatusEnum.ACTIVE,
          items: null,
        },
      ],
      modal: {
        createView: false,
        deleteView: false,
        confirm: false,
      },
      input: {
        root: null,
        id: null,
        parent_id: null,
        level: 0,
        code: null,
        display_name: {
          th: '',
          en: '',
        },
        commission_rate: null,
        is_control_product: false,
        is_commission_rate: false,
        status: StatusEnum.ACTIVE,
        categories_mapped: [
          {
            type: null,
            id: null,
            parent_id: null,
            level: 0,
            code: null,
            mdc_code: 0,
            display_name: {
              th: '',
              en: '',
            },
            parent_categories: [
              {
                id: null,
                parent_id: null,
                level: 0,
                code: null,
                mdc_code: 0,
                display_name: {
                  th: '',
                  en: '',
                },
              },
            ],
          },
        ],
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      fieldsDetail: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'name',
          label: 'ชื่อหมวดหมู่',
          sortable: true,
        },
        {
          key: 'root',
          label: 'Root',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      isValidate: {
        commission_rate: false,
      },
      displayCheckBox: false,
      seletedViewId: '',
      parent_id: null,
      parent_status: null,
      level: 0,
      root: null,
      commission_rate: null,
      isCreateFormRoot: false,
      isEdit: false,
      isShowData: false,
      isPayloadChanged: false,
      is_child: false,
      lockLevel: HybridLockLevel,
      statusNotCreate: ['Delete'],
      messageAlertConfirm: '',
    }
  },
  created() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
    } else {
      this.id = this.$route.params.id
    }
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode
    }
  },
  async mounted() {
    await this.getTreeModel()
    if (this.mode !== 'new') {
      this.isShowData = true
      this.isEdit = this.mode === 'view' ? false : true
      await this.getViewById(this.id)
    }
  },
  computed: {
    isShowEditBtn() {
      return !(
        this.input.status === 'Delete' || this.input.status === 'Pending'
      )
    },
  },
  methods: {
    async getHybridProductSku(id) {
      var result = await hybridCategoryService.getHybridProductSkuListAsync(id)

      if (result.status === 200) {
        console.log(result.data.skus)
        var countStatusProductDelete = 0
        var countStatusProductAnother = 0
        result.data.skus.forEach(element => {
          if (element.inventory_status === 'Delete') {
            countStatusProductDelete++
          } else {
            countStatusProductAnother++
          }
        })

        if (result.data.skus.length === 0) {
          this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
        } else {
          if (countStatusProductDelete === result.data.skus.length) {
            this.messageAlertConfirm =
              'มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่'
          } else if (
            countStatusProductAnother === result.data.skus.length ||
            (countStatusProductAnother !== 0 && countStatusProductDelete !== 0)
          ) {
            this.messageAlertConfirm =
              'มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่'
          } else {
            this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
          }
        }
      } else {
        this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
      }
    },
    async onSubmit() {
      if (this.messageAlertConfirm !== '') {
        this.$utils
          .confirmAlertDisplay(this.messageAlertConfirm, '')
          .then(async result => {
            if (result) await this.onSave()
          })
      } else await this.onSave()
    },
    onSave() {
      this.$refs.detailEditor.$refs.addDataForm
        .validate()
        .then(async response => {
          if (response) {
            let params = new URLSearchParams()
            params.append('id', this.input.id)
            let result = await hybridCategoryService.headMappingHybridCategoryAsync(
              params
            )
            if (result.status === 200) {
              var textConfirm =
                this.input.status === 'Delete'
                  ? 'ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่'
                  : 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
              await this.$utils
                .confirmAlertDisplay(textConfirm, '')
                .then(result => {
                  if (result) {
                    this.onConfirmSave()
                  }
                })
            } else if (
              (result.status && result.status === 404) ||
              (result.response.status && result.response.status === 404)
            ) {
              if (this.input.status === 'Delete') {
                this.$utils.notification(
                  'error',
                  'มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ไม่สามารถปรับสถานะเป็น Delete ได้',
                  2000
                )
              } else {
                await this.$utils
                  .confirmAlertDisplay(
                    `มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่`,
                    ''
                  )
                  .then(result => {
                    if (result) {
                      this.onConfirmSave()
                    }
                  })
              }
            } else if (
              (result.status && result.status !== 500) ||
              (result.response && result.response.status !== 500)
            ) {
              if (result.response.data.message) {
                this.$utils.notification(
                  'error',
                  result.response.data.message,
                  2000
                )
              } else {
                this.$utils.notification(
                  'error',
                  'Bad request: Unkonw error',
                  2000
                )
              }
            }
          }
        })
    },
    async onConfirmSave() {
      let result = await hybridCategoryService.updateAllHybridApprovalAsync(
        this.input.id,
        this.input
      )
      if (result.status === 201) {
        let approval_document = result.data.approval_documents[0]
        this.$utils.notificationAck(
          'success',
          'เพิ่มข้อมูลสำเร็จ',
          `สร้างเอกสาร Request เลขที่ ${result.data.id} <br> เอกสารขออนุมัติ ${approval_document.rule_id}(${approval_document.rule_name.th}) เลขที่ <a href='/requests/${result.data.id}/approvals/${approval_document.approval_document_id}' >${approval_document.approval_document_id} </a> สำเร็จ`
        )
      } else if (result.status && result.status === 204) {
        await this.getViewById(this.input.id)
        await this.getTreeModel()
        this.isEdit = false
        this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notificationAck('error', result.response.data.message)
      }
    },
    async onCreateNode(model) {
      // this.parent_id = model.view_id === '' ? null : model.view_id
      // this.level = model.level
      // this.isCreateFormRoot = model.view_name === 'Root' ? true : false
      // this.modal.createView = true

      this.isCreateFormRoot = model.view_name === 'Root' ? true : false
      this.level = !this.isCreateFormRoot ? model.level + 1 : 1
      this.parent_id = model.view_id === '' ? null : model.view_id
      this.parent_status = model.status
      if (this.parent_status === 'Delete') {
        this.$utils.notificationAck(
          'error',
          'เพิ่มข้อมูลไม่สำเร็จ',
          `ไม่สามารถดำเนินการได้ เนื่องจากสถานะของ level ก่อนหน้าเป็น Delete`
        )
      } else {
        this.root = null
        this.commission_rate = null
        if (this.level !== 1) {
          let params = new URLSearchParams()
          params.append('isRequireParent', false)
          let result = await hybridCategoryService.getHybridCategoryDetailAsync(
            this.parent_id,
            params
          )
          if (result.status === 200) {
            this.root =
              this.level === 2
                ? result.data.display_name.th + ' (' + result.data.code + ')'
                : result.data.root +
                  ' > ' +
                  result.data.display_name.th +
                  ' (' +
                  result.data.code +
                  ')'
            this.commission_rate = result.data.commission_rate.toString()
          }
        }
        this.modal.createView = true
      }
    },
    onDeleteNode(model) {
      this.modal.deleteView = true
      this.seletedViewId = model.view_id
    },
    async getTreeModel() {
      let params = new URLSearchParams()
      let result = await hybridCategoryService.getHybridCategoryTreeNodeAsync()
      if (result.status === 200) {
        if (result.data.length) {
          this.treeModel[0].items = result.data
        }
      }
    },
    async anyChildHybridCategory(id) {
      let result = await hybridCategoryService.anyChildHybridCategoryDetailAsync(
        id
      )
      if (result.status === 200) {
        return result.data
      } else {
        return false
      }
    },
    async getStatusParentHybridCategory(parentId) {
      let result = await hybridCategoryService.getStatusParentHybridCategoryAsync(
        parentId
      )
      if (result.status === 200) {
        return result.data
      } else {
        return ''
      }
    },
    async getViewById(viewId) {
      let params = new URLSearchParams()
      params.append('isRequireParent', false)
      let result = await hybridCategoryService.getHybridCategoryDetailAsync(
        viewId,
        params
      )
      if (result.status === 200) {
        let _input = result.data
        this.is_child = await this.anyChildHybridCategory(viewId)
        if (_input.parent_id != null) {
          _input.parent_status = await this.getStatusParentHybridCategory(
            _input.parent_id
          )
          if (
            _input.parent_status !== 'Active' &&
            _input.parent_status !== ''
          ) {
            _input.status = _input.parent_status
          }
        } else {
          _input.parent_status = ''
        }

        _input.commission_rate =
          _input.commission_rate === 0 ? '0' : _input.commission_rate
        _input.is_commission_rate = false
        var categoriesMappedItems = []
        if (_input.categories_mapped.length > 0) {
          _input.categories_mapped.forEach(element => {
            var root = ''
            let tempCategoriesMapped = {
              id: element.id,
              parent_id: element.parent_id,
              name: element.type,
              root: null,
            }
            element.parent_categories.forEach(e => {
              var _displayName = e.display_name.th
                ? e.display_name.th
                : e.display_name.en
              root += _displayName + ' (' + e.code + ')' + ' > '
            })
            var __displayName = element.display_name.th
              ? element.display_name.th
              : element.display_name.en
            root += __displayName + ' (' + element.code + ')'
            tempCategoriesMapped.root = root
            categoriesMappedItems.push(tempCategoriesMapped)
          })
        }
        _input.categoriesMappedItems = categoriesMappedItems
        this.input = _input
      }
    },
    async createView(data) {
      data.level = this.level
      data.parent_id = this.parent_id
      let result = await hybridCategoryService.createHybridCategoryAsync(data)
      if (result.status === 201) {
        await this.getTreeModel()
        this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ', 1500)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }

      this.modal.createView = false
    },

    allowDrag(model, component) {
      // if (model.name === "Node 0-1") {
      //   // can't be dragged
      //   return false;
      // }
      // // can be dragged
      // return true;
      return false
    },
    allowDrop(model, component) {
      // if (model.name === "Node 2-2") {
      //   // can't be placed
      //   return false;
      // }
      // // can be placed
      // return true;
      return false
    },
    async curNodeClicked(model, component) {
      if (model.view_id !== null) {
        this.isShowData = true
        this.isEdit = false
        await this.getViewById(model.view_id)
      } else {
        this.isShowData = false
      }
    },
    async onEdit() {
      if (this.input.id !== null) {
        this.isEdit = true
        await this.getHybridProductSku(this.input.id)
        await this.getViewById(this.input.id)
      }
    },
    async onCancel() {
      if (this.input.id !== null) {
        this.isEdit = false
        await this.getViewById(this.input.id)
      }
    },
    onBack() {
      this.$router.push({
        path: '/hybrid-categories',
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.getViewById(this.input.id)
            this.isValidate = {
              commission_rate: false,
            }
          }
        })
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    },
  },
}
</script>
